import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Subject } from "rxjs";
import { SingleSkuPriceSettingsComponent } from "src/app/modules/detail/presentational/single-sku-price-settings/single-sku-price-settings.component";

@Component({
  selector: "app-priceyard-panel",
  templateUrl: "./priceyard-panel.component.html",
  styleUrls: ["./priceyard-panel.component.scss"],
})
export class PriceyardPanelComponent implements OnDestroy {
  edit: boolean = false;
  _selectedSku: any;
  private _activeTab: string;
  isSidePanel: boolean;
  @Input() selectedMarkupType: any[] = [];
  private destroy$ = new Subject<void>();
  @Input() get selectedSku() {
    return this._selectedSku;
  } 
  set selectedSku(value) {
    this._selectedSku = value;
  }
  get activeTab() {
    return this._activeTab;
  }
  set activeTab(tab: string) {
    this._activeTab = tab;
  }
  @Output() editEvent: EventEmitter<any> = new EventEmitter();
  constructor() {
    this.isSidePanel = localStorage.getItem("toolPanel") === "true";
  }

  ngOnInit(): void {
    this.activeTab = "Dashboard";
  }

  togglePriceEdit() {
    this.editEvent.emit({
      component: SingleSkuPriceSettingsComponent,
      title: "Edit",
      id: this.selectedSku.sku,
    });
  }

  tabClicked(e) {
    this.activeTab = e; 
  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}
